//region :: Imports ::
import MComponent from '../Component';
import {ReactElement} from 'react';

//endregion

/** */
type Props = {
    id?: string;
    text?: string;
}

/** */
class MErrorText extends MComponent<Props> {

    /** */
    public render(): ReactElement | null {

        return this.props.text === undefined || this.props.text.length === 0
               ? null : (<small id={this.props.id} className="p-error block font-medium">{this.props.text}</small>);

    }

}

export default MErrorText;
